export interface AboutInfo {
  brandName: string;
  brandIntro: string;
  mission: string;
  vision: string;
  values: { title: string; description: string }[];
  milestones: { year: string; event: string }[];
  teamIntro: string;
  certifications: { name: string; description: string }[];
  contact: {
    email: string;
    phone: string;
    address: string;
    workingHours: string;
  };
}

export const aboutInfo: AboutInfo = {
  brandName: '十八禁合规指引平台',
  brandIntro: '十八禁合规指引平台成立于2024年，是国内领先的成人内容合规教育平台。我们致力于为成年用户和内容行业从业者提供全面、专业、及时的合规知识和实用指引。平台汇聚了法律、技术、心理学等多领域的专家学者，以严谨的治学态度和务实的研究精神，推动成人内容行业的规范化发展。',
  mission: '通过专业的合规教育和科学的知识普及，帮助成年用户建立正确的成人内容认知框架，引导行业从业者建立规范的运营体系，促进成人内容行业在合法合规的轨道上健康发展。',
  vision: '成为中文世界最具权威性和影响力的成人内容合规教育平台，推动行业标准的确立和完善，为构建清朗的网络空间贡献力量。',
  values: [
    { title: '专业严谨', description: '所有内容均经过法律专家审核，确保信息的准确性和权威性。' },
    { title: '客观中立', description: '坚持客观中立的研究立场，不偏袒任何利益相关方。' },
    { title: '用户至上', description: '以用户需求为导向，持续优化内容和服务体验。' },
    { title: '社会责任', description: '积极承担社会责任，重点关注未成年人保护和网络环境净化。' },
  ],
  milestones: [
    { year: '2024年3月', event: '平台正式上线，发布首批法律法规解读文章' },
    { year: '2024年6月', event: '内容分级专栏上线，覆盖全球主要分级体系' },
    { year: '2024年9月', event: '月度访问用户突破10万，获得行业广泛关注' },
    { year: '2025年1月', event: '安全指引专栏上线，拓展心理健康内容方向' },
    { year: '2025年6月', event: '与多家高校法学院建立合作关系' },
    { year: '2026年3月', event: '平台内容累计超过50篇深度研究文章' },
  ],
  teamIntro: '我们的团队由法律专家、技术工程师、心理学研究员、内容编辑等多元背景的专业人士组成。核心成员均拥有相关领域的深厚积累和丰富经验。团队秉持专业与责任并重的理念，持续为用户提供高质量的合规指引内容。',
  certifications: [
    { name: '网络内容安全合规认证', description: '通过国家相关部门的内容安全合规评估认证' },
    { name: '个人信息保护合规认证', description: '符合个人信息保护法要求的数据安全管理体系' },
    { name: '行业自律公约签署单位', description: '互联网内容行业自律公约签署成员单位' },
  ],
  contact: {
    email: 'contact@shibajin-compliance.cn',
    phone: '400-XXX-XXXX',
    address: '北京市朝阳区XX路XX号',
    workingHours: '周一至周五 9:00-18:00',
  },
};